App.controller('HealthInsuranceWithPaymentsRefundCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsuranceWithPayments_refund';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Refundacja';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.healthInsuranceWithPayments.start';
    $scope.$emit('link', $scope.link);
}]);